import styled from 'styled-components';

export const Separator = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 34px;
  width: 100%;
`
